export function hasUserInteracted() {
  return !navigator.userActivation || navigator.userActivation.hasBeenActive;
}

export function focusElement(element?: HTMLElement | null) {
  if (hasUserInteracted()) {
    element?.focus();
  }
}
